import svgConnect from "../../../../assets/imgs/socials/connects/instagram.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/instagram.svg";

import MyImage from "../../../myImage"

const MyIconInstagram = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'instagram icon'} sx={sx} />

export default MyIconInstagram;
